import { FormData } from '../../pages/candidates/incidents/IncidentsCandidate'
import { BASE_URL } from '../endpoints'
import { get, post } from '../https'

export const getAllIncidents = (
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/incidents/my?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}
export const addIncident = (data: FormData): Promise<unknown> => {
  return post(`${BASE_URL}/incidents/my`, data, null)
}
